var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":"Admin: Link Tree"}},[_c('v-container',_vm._l((_vm.links),function(item,index){return _c('div',{key:index},[_c('m-edit-text',{attrs:{"label":item.text,"value":item.value,"read_only":"","hyperlink":""}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }